import { render } from "./MapSwitcher.vue?vue&type=template&id=1458a9b0"
import script from "./MapSwitcher.vue?vue&type=script&lang=js"
export * from "./MapSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__